import React, { useState, useEffect, useRef } from 'react';
import Header from "../../../Components/Header/Header";
import LeftMenu from '../../../Components/LeftMenu/LeftMenu';
import ImageUpload from '../../../Components/common/ImageUpload';
import ActivityComments from '../../../Components/common/ActivityComments';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Col, Row, Table, Dropdown, Modal, Tab, Tabs, Stack, Button, Form, Accordion } from 'react-bootstrap';
import { faPlus, faXmark, faPencil, faPaperclip, faCalendarDays, faCircleXmark, faLink, faCircleCheck, faChevronDown, faGear } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import Docmnt from '../../../assets/images/google-docs.png';
import Arcv from "../../../assets/images/archive.svg";
import Activ from "../../../assets/images/active.svg";
import edit from "../../../assets/images/edit.png";
// import view from "../../../assets/images/view.png";
import AssetsIcon from '../../../assets/images/assets.svg';
import OperationIcon from '../../../assets/images/oparation.svg';
import OnAirIcon from '../../../assets/images/onair.svg';
import AssetsIconA from '../../../assets/images/assets_a.svg';
import OperationIconA from '../../../assets/images/oparation_a.svg';
import OnAirIconA from '../../../assets/images/onair_a.svg';

import { withoutRFSToken, withRFSToken } from '../../../Services/axios.js';
import { GETULDDETAILS, MOVETOACTARC, RECOVERYARCACT, RECOVERYDETAILS, } from '../../../Utils/conts.js';
import AddRecovery from './AddRecovery';
import { toast } from 'react-toastify';

import Dashboard from './Dashboard.js';
import Overview from './Overview.js';
import Inbox from './Inbox.js';
import TaskManagement from './TaskManagement.js'; 
import DocManagement from './DocManagement.js';

const ServiceRecovery = () => {

    const initialTab = localStorage.getItem("asr_tab") || 'overview';
    const isMounted = useRef(false);
    const [selectedButton, setSelectedButton] = useState(initialTab);

    useEffect(() => {
        setSelectedButton(initialTab);
    }, [initialTab]);

    const handleButtonClick = (button) => {
        setSelectedButton(button);
        localStorage.setItem('asr_tab', button);
    };


    return (
        <>
            <div className="">
                <Header page_type='srecovery' logo_url='/ServiceRecovery' />
                <div className='d-flex justify-content-between slot_plan_hd'>
                    <div className='new_menu_serv'>
                        <button className={selectedButton === 'dashboard' ? 'exportbtn me-3 active' : 'exportbtn me-3'} onClick={() => handleButtonClick('dashboard')}>
                            <img src={selectedButton === 'dashboard' ? AssetsIconA : AssetsIcon} /> <span>Dashboard</span>
                        </button>
                        <button className={selectedButton === 'overview' ? 'exportbtn me-3 active' : 'exportbtn me-3'} onClick={() => handleButtonClick('overview')}>
                            <img src={selectedButton === 'overview' ? OperationIconA : OperationIcon} /> <span>Overview</span>
                        </button>
                        <button className={selectedButton === 'inbox' ? 'exportbtn me-3 active' : 'exportbtn me-3'} onClick={() => handleButtonClick('inbox')}>
                            <img src={selectedButton === 'inbox' ? OnAirIconA : OnAirIcon} /> <span>Inbox</span>
                        </button>
                        <button className={selectedButton === 'task' ? 'exportbtn me-3 active' : 'exportbtn me-3'} onClick={() => handleButtonClick('task')}>
                            <img src={selectedButton === 'task' ? OnAirIconA : OnAirIcon} /> <span>Task Management</span>
                        </button>
                        {/* <button className={selectedButton === 'doc' ? 'exportbtn me-3 active' : 'exportbtn me-3'} onClick={() => handleButtonClick('doc')}>
                            <img src={selectedButton === 'doc' ? OnAirIconA : OnAirIcon} /> <span>Doc Management</span>
                        </button> */}
                    </div>
                </div>
                <div className="page-body-wrapper schedule">
                    <LeftMenu />
                    <div className="main-panel rounded">
                        <div className="mainTab">
                            <div className="lcontent">
                                {/* <div className='d-flex justify-content-between mb-3'>
                                    <div>
                                        <button className={selectedButton === 'dashboard' ? 'exportbtn me-3 active' : 'exportbtn me-3'} onClick={() => handleButtonClick('dashboard')}>
                                            <img src={selectedButton === 'dashboard' ? AssetsIconA : AssetsIcon} /> <span>Dashboard</span>
                                        </button>
                                        <button className={selectedButton === 'overview' ? 'exportbtn me-3 active' : 'exportbtn me-3'} onClick={() => handleButtonClick('overview')}>
                                            <img src={selectedButton === 'overview' ? OperationIconA : OperationIcon} /> <span>Overview</span>
                                        </button>
                                        <button className={selectedButton === 'inbox' ? 'exportbtn me-3 active' : 'exportbtn me-3'} onClick={() => handleButtonClick('inbox')}>
                                            <img src={selectedButton === 'inbox' ? OnAirIconA : OnAirIcon} /> <span>Inbox</span>
                                        </button>
                                        <button className={selectedButton === 'task' ? 'exportbtn me-3 active' : 'exportbtn me-3'} onClick={() => handleButtonClick('task')}>
                                            <img src={selectedButton === 'task' ? OnAirIconA : OnAirIcon} /> <span>Task Management</span>
                                        </button>
                                    </div>
                                </div> */}
                                <div className="lcontent">
                                    {selectedButton === 'dashboard' && <Dashboard />}
                                    {selectedButton === 'overview' && <Overview />}
                                    {selectedButton === 'inbox' && <Inbox />}
                                    {selectedButton === 'task' && <TaskManagement />}
                                    {/* {selectedButton === 'doc' && <DocManagement />} */}
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ServiceRecovery;